export default __webpack_public_path__ + "static/media/studies.a2ff5826.svg";